export { XPayStationWidgetService } from './XPayStationWidget.service';
export * from './core.module';
